module.exports = __webpack_public_path__ + "80ba6be4e96b7b40c941bd707933ac91.jpg";